import { IAnswerModel } from '../../../state/stores/Question/AnswerModel';
import { SnapshotOrInstance } from 'mobx-state-tree';
import { useEffect } from 'react';
import { useStores } from '../../../hooks/useStores';

interface UseInitChoiceWithFirstAnswerOpts {
  answers?: SnapshotOrInstance<IAnswerModel>[];
  questionId: string;
  questionKey: string;
  findInitialChoice?: (answer: SnapshotOrInstance<IAnswerModel>) => boolean
}

export const useInitChoiceWithFirstAnswer = ({
  answers,
  questionId,
  questionKey,
  findInitialChoice = () => true,
}: UseInitChoiceWithFirstAnswerOpts): [SnapshotOrInstance<IAnswerModel> | undefined] => {
  const { treeNav } = useStores();
  const isReady = treeNav.choices.pending?.questionId === questionId;
  const hasChosen = !!treeNav.choices.pending?.answers.length;
  const choiceOutdated = !treeNav.choices.pending?.specialTypeOfAnswer && !treeNav.choices.pending?.answers.every(a => answers?.some(qa => a.id === qa._id));
  const initAnswer = answers?.find(findInitialChoice);
  const initAnswerId = initAnswer?._id;
  const initAnswerKey = initAnswer?.key;
  const initAnswerMeta = initAnswer?.meta;
  const initAnswerSpecial = initAnswer?.specialTypeOfAnswer;
  useEffect(() => {
    if (isReady && (!hasChosen || choiceOutdated) && initAnswerId) {
      treeNav.choices.setPending({
        questionId,
        questionKey,
        answers: [{
          id: initAnswerId,
          key: initAnswerKey,
          meta: initAnswerMeta,
        }],
        specialTypeOfAnswer: initAnswerSpecial,
      });
    }
  }, [initAnswerId, initAnswerKey, initAnswerMeta, initAnswerSpecial, hasChosen, isReady, questionId, questionKey, treeNav, choiceOutdated]);
  return [answers?.find(a => treeNav.choices.pending?.answers.some(c => c.id === a._id))];
};
